// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

import axios from 'axios'
import { Picker } from 'vant';
import { Field } from 'vant';
import { Toast } from 'vant';
import { Popup } from 'vant';
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Field);
import 'vant/lib/index.css';

//引用组件
import Loading from './components/components/loading.vue';
import popupWin from './components/components/popupWin.vue';



Vue.use(Loading)
Vue.use(popupWin)
Vue.component('Loading',Loading)//初始化组件
Vue.component('popupWin',popupWin)//初始化组件
// main.js文件中引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


// 时间选择器
import { Cell, CellGroup } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);
import { Calendar } from 'vant';
Vue.use(Calendar);
import { DatetimePicker } from 'vant';
Vue.use(DatetimePicker);

// 引用API文件
import api from '../static/js/index.js'
import util from '../static/js/util.js'
import dateUtil from '../static/js/dateUtil.js'
import explain from '../static/js/calculationExplain'



// 将API方法绑定到全局
Vue.prototype.$api = api
Vue.prototype.$util = util
Vue.prototype.$dateUtil = dateUtil
Vue.prototype.$explain = explain

Vue.config.productionTip = false
//进入页面直接回到顶部
router.afterEach(route => {
  window.scrollTo(0,0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js